import { Helmet } from 'react-helmet-async';
import { SearchBar } from '../components/SearchBar';
import './HomePage.css';

export const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>POM Data - Ingredient Safety Database</title>
        <meta name="description" content="Search and explore comprehensive ingredient safety information. Learn about food additives, chemicals, and their potential health impacts." />
      </Helmet>
      
      <div className="home-page">
        <div className="home-content">
          <h1>POM Data</h1>
          <p className="tagline">Ingredient Safety Information Database</p>
          
          <div className="description">
            <p>
              Welcome to POM Data, your comprehensive resource for ingredient safety information.
              Search for any ingredient to learn about its properties, safety profile, and potential health impacts.
            </p>
          </div>

          <div className="search-section">
            <SearchBar />
          </div>

          <div className="quick-links">
            <h2>Try These Examples</h2>
            <div className="ingredient-links">
              <a href="/red-40" className="ingredient-link">
                Red 40
              </a>
              <a href="/aspartame" className="ingredient-link">
                Aspartame
              </a>
              <a href="/mono-and-diglycerides" className="ingredient-link">
                Mono and Diglycerides
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
